<div class="capital-maintence-view">
  <div class="uitk-l-grid__col--sm-12 uitk-l-grid__col--m-12 uitk-l-grid__col--lg-12">
    <div class="uitk-c-card uhc-font">
      <div class="row">
        <div class="d-flex justify-content-end align-items-center toggle-div">
          <span class="switch-toggle-label me-1 toggle-ytd-label">Segment</span>
          <mat-slide-toggle
            [color]="'#013b71'"
            class="toggle-margin app-toggle"
            [(ngModel)]="checked"
            (change)="onToggleChange($event.checked)"
          ></mat-slide-toggle>
          <span class="switch-toggle-label ms-1 toggle-ytd-label">Leader</span>
        </div>
      </div>
      <div class="uitk_new_header">
        <div class="uitk-l-grid__col--12 stk-container-tabl-header">
          <div class="stk-header-action row">
            <div class="table-header-icons col-md-12 col-sm-12 col-lg-12 col-xl-12 col-xs-12">
              <ng-container>
                <div class="table-search col-md-3 col-sm-3 col-lg-3 col-xl-3 col-xs-3">
                  <mat-form-field class="data-filter cd-table-search" appearance="outline" style="padding: 0px;">
                    <input
                      [(ngModel)]="searchField"
                      matInput
                      type="text"
                      class="capability-search"
                      placeholder="Search Funding Segment ID/Segment/Owner/UCMG ID/UCMG Name"
                      (keyup)="searchDataSet()"
                    />
                    <img src="../../../../assets/images/searchicon.png" class="lob-view-search-img" />
                  </mat-form-field>
                </div>
              </ng-container>
              <ng-container>
                <div class="col-md-4 col-sm-4 col-lg-4 col-xl-4 col-xs-4 ps-0 capital-demand-filter-block">
                  <div class="form-group w-50 pe-2">
                    <app-dropdown-with-search
                      [Pixeltracking]="true"
                      searchFlag="false"
                      placeholder="Fiscal Year"
                      showPlaceholder="true"
                      isMultiSelect="false"
                      [dropdownData]="yearList"
                      [selected]="ucmgYear"
                      (selectionChange)="onYearChange($event)"
                    ></app-dropdown-with-search>
                  </div>
                  <div class="form-group w-50">
                    <app-dropdown-with-search
                      [Pixeltracking]="true"
                      searchFlag="false"
                      placeholder="Investment Status"
                      showPlaceholder="true"
                      isMultiSelect="true"
                      [dropdownData]="statusList"
                      [selected]="selectedStatusList"
                      (selectionChange)="setSelectedValues($event)"
                    ></app-dropdown-with-search>
                  </div>
                </div>
              </ng-container>
              &nbsp;
              <div class="table-header-icons table-header-icons-buttons">
                <ng-container>
                  @if (restrictionInvesterEdit) {
                  <button
                    (click)="addUcmg()"
                    class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs"
                  >
                    Add
                  </button>
                  }
                </ng-container>
                &nbsp; @if (dataSourceDetails && dataSourceDetails.data.length) {
                <div (click)="exportToCsv()" class="export-link">
                  <span
                    title="Click to Download"
                    class="uitk-icon uitk-icon-download md-icon excel_Download excelandinfo-Icon-font"
                  ></span>
                </div>
                }
              </div>
            </div>
            <!-- KPIs -->
            @if (showKPI) {
            <div class="details-card details-card-margin">
              <div class="card-structure optum-font">
                <div class="top-card-hlist">
                  <div class="top-card-hlist-items">
                    <div class="top-card-hlist-box">
                      <div class="top-card-hlist-pill-headers hlist-titles">Total Forecast</div>
                      <div class="pill-detail preferred">
                        <span class="pill-moneyfield">
                          ${{ totalForecastKPI.value | BillionsToBMillionsToMThousandsToK }}</span
                        >
                      </div>
                    </div>
                  </div>
                  <div class="top-card-hlist-items">
                    <div class="top-card-hlist-box">
                      <div class="top-card-hlist-pill-headers hlist-titles">Total OT Forecast</div>
                      <div class="pill-detail preferred">
                        <span class="pill-moneyfield">
                          ${{ ucmgOTKPI?.value | BillionsToBMillionsToMThousandsToK }}</span
                        >
                      </div>
                    </div>
                  </div>
                  <div class="top-card-hlist-items">
                    <div class="top-card-hlist-box">
                      <div class="top-card-hlist-pill-headers hlist-titles hlist-title-long">
                        Total Leader OT Allocation
                      </div>
                      <div class="pill-detail preferred">
                        <span class="pill-moneyfield">
                          ${{ totalOTKPI.value | BillionsToBMillionsToMThousandsToK }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            }
          </div>
        </div>
        <div class="uitk-c-card__content" style="margin-top: 0px !important;">
          <div class="stk-table-container">
            @if (showLoader) {
            <div class="stk-table-loader">
              <app-loader></app-loader>
            </div>
            } @if (!showLoader) {
            <app-capital-maintenance-table
              [TABLE_CONFIG]="TABLE_CONFIG"
              [COLUMNS]="TABLE_COLUMNS"
              (reloadData)="handleAppicationload()"
              [SORT_CONFIG]="sortConfig"
              [dataSource]="dataSourceDetails"
              [childDataSource]="dataSourceDetails"
              [SCHEMA]="DATA_SCHEMA"
              (searchEvent)="searchEvent($event)"
              (checkBoxEvent)="checkBoxEvent($event)"
              [pageSize]="TABLE_CONFIG.pageSize"
              [pageIndex]="TABLE_CONFIG.pageIndex"
              [exportToExcel]="exportToExcel"
              [selectedOption]="selectedOption"
              (dataRefresh)="dataRefresh($event)"
              [filterSegment]="tempFilterSegment"
              [yearList]="yearList"
              [currentTable]="currentTable"
              [ucmgYear]="ucmgYear"
              [selectedStatusList]="selectedStatusList"
              [searchedText]="searchedText"
            ></app-capital-maintenance-table>
            }
          </div>
        </div>
      </div>
      <app-modal class="modal-demo add-icon" [maximizable]="true" #addUcmgPopup (closeModal)="closeAddModal('addUcmg')">
        <ng-container class="app-modal-header">
          <div style="display: flex; width: 100%;">
            <div style="width: 98%;">ADD UCMG</div>
            <div style="display: flex; align-items: center;">
              <span
                class="popup-info-button uitk-icon uitk-icon-info_hollow health md-icon for-media excelandinfo-Icon-font info-icon icon-size"
                matTooltipPosition="left"
                title="Info"
                (click)="showpopup()"
              ></span>
            </div>
          </div>
        </ng-container>
        <ng-container class="app-modal-body p-0">
          <app-add-ucmg
            [yearList]="yearList"
            [investmentStatus]="statusList"
            [filterSegment]="tempFilterSegment"
            (dataRefresh)="refreshAddData($event)"
            [capitalDemandRecords]="capitalDemandRecords"
          ></app-add-ucmg>
        </ng-container>
      </app-modal>
    </div>
  </div>
</div>
